<template>
  <nav class="navbar-default">
    <div class="row mr-3 ml-3 pt-3 mb-3 barra">
      <div class="navbar-minimize col-1">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header col-3">
        <a class="navbar-brand">{{this.$route.name}}</a>
      </div>
      <div class="col-6">
        <div class="nombre">
          <h5>{{this.nombre}}</h5>
        </div>
        <div class="nombre">
          <p class="text-muted ente">{{this.ente}}</p>
        </div>

        <div class="notificaciones">

          <v-badge :color="(this.lngth>0) ? 'red' : 'white'" :content="this.lngth">
            <v-icon color="white" large @click="menu=!menu" small>
              ti-bell
            </v-icon>
          </v-badge>

          <ul :class="menu ? 'dropdown-menu show' : 'dropdown-menu'">
            <v-list three-line v-if="this.lngth>0">
              <template v-for="(item, index) in notificaciones">
                <v-list-item :key="item.title" @click="">
                  <v-list-item-content>
                    <v-list-item-title v-html="item.texto"></v-list-item-title>
                    <v-list-item-subtitle v-if="item.id_tipo!=1" v-html="item.movimiento.servidor.rfc"></v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <a class="dnotif" @click="irNot()">Ver más</a>
            </v-list>

            <template v-else>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Sin Notificaciones</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </ul>

        </div>

      </div>

      <div class="col-2 position-relative">
        <v-btn text color="white" small @click.prevent="cerrarSesion" class="ml-2 mr-2">
          Cerrar Sesión
        </v-btn>
        <div class="ribbon ribbon-top-right" v-if="$rootUrl == '//localhost:8000' || $rootUrl == '/declaranet/'"><span>PRUEBAS</span></div>
        <!--  <div @click="abreSubM" class="btn-rotate float-right h3 m-0">
          <i class="ti-power-off"></i>
        </div> -->
      </div>
    </div>
  </nav>
</template>
<script>
  import {
    eventBus
  } from '../../../main'
  export default {
    data() {
      return {
        activeNotifications: false,
        nombre: '',
        lngth: 0,
        ente: '',
        menu: false,
        notificaciones: []
      }
    },
    watch: {
      '$route': 'getNotificaciones'
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar() {
        this.$sidebar.toggleMinimize()
      },
      cerrarSesion() {
        localStorage.clear();
        eventBus.$emit('cerro');
        this.$router.push('/login');
      },
      abreSubM() {
        var v = this;
        var color = Math.floor((Math.random() * 4) + 1)
        this.$notify({
          component: {
            template: `
              <div @click="cerrarSesion" href="javascript:void(0)"  >
                Cerrar Sesión
              </div>`,
            methods: {
              cerrarSesion() {
                localStorage.clear();
                eventBus.$emit('cerro');
                v.$router.push('/login');
              }
            }
          },
          icon: 'ti-lock',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'info',
          timeout: 150000
        })
      },
      getNotificaciones() {
        this.$http.get("notificaciones").then(
          response => {

            this.notificaciones = response.data.notificaciones;
            this.lngth = this.notificaciones.length
            this.notificaciones = this.notificaciones.slice(0, 5);
          },
          error => {
            this.StepError(error);
          }
        );
      },

      leida(id) {
        this.$http.delete("notificaciones/" + id).then(
          response => {
            this.getNotificaciones()
          },
          error => {
            this.StepError(error);
          }
        );
      },
      irNot() {
        this.$router.push('/admin/notificaciones')
      }
    },
    created() {
      this.nombre = this.getKey('nombre');
      this.ente = this.getKey('ente');
      this.getNotificaciones()
    }
  }

</script>
<style>
  .nombre {
    padding-bottom: 0% !important;
    margin-bottom: 0% !important;
    text-align: right !important;
    margin-bottom: 5px !important;
  }

  .notificaciones {
    padding-bottom: 0% !important;
    margin-bottom: 0% !important;
    margin-bottom: 5px !important;
    padding-top: 5px !important;
    width: 20px !important;
    float: right !important;
  }

  h5,
  .h5 {
    font-size: 1.2em !important;
    margin-bottom: 5px;
  }

  .notiftxt {
    font-size: .7em !important;
  }

  .dnotif {
    font-size: .75em !important;
    float: right;
  }

  .ente {
    font-size: 12px !important;
    line-height: 1em !important;
    margin-bottom: 5px !important;
  }

  .barra {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 5px !important;
    margin-top: 0 !important;
  }

  .row.mr-3.ml-3.pt-3.mb-3.barra {
    padding-top: 10px !important;
    margin-bottom: 5px !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .pt-3,
  .py-3 {
    padding-top: 10px !important;
  }

  .info {
    color: white;
    background-color: transparent !important;
  }

  .notif {
    color: white;
    background-color: transparent !important;
  }

  .notifa {
    color: red;
    background-color: transparent !important;
    font-size: 1.3em !important;
  }

  .dropdown-menu {
    margin-left: 65% !important;
    width: 225px !important;
  }

  .li {
    width: 250px !important;
  }

  .dropdown-menu>li>a {
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }

  .v-list-item__content {
    align-items: center;
    align-self: center;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1;
    overflow: hidden;
    height: 50px;
    padding: 3px;
  }

  .v-list-item {
    height: 50px;
  }

  .v-list--three-line .v-list-item,
  .v-list-item--three-line {
    min-height: 50px;
  }

  .v-list-item:hover {
    background-color: #c1d4fd !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue